"use client";

import { EventTrackingDataType } from "@/types/common";
import { getCookie, getPageName, getSiteProps, loadScript } from "@/utils";
import cleverTapAndMixPanelEvents from "@/utils/eventTracking";
import { prepareLeftFooterData, prepareRightFooterData } from "@/utils/footer";
import { getZunoScript } from "@/utils/zuno";
import { Footer } from "@monsterindia/global-ui-components";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import FooterSkeleton from "./FooterSkeleton";
import { getFooterData } from "./query";
import { FooterProps } from "./types";

const FooterComponent: React.FC<FooterProps> = ({ host, isLoggedIn }) => {
  const { data, isLoading, isError } = getFooterData();
  const siteProps = getSiteProps(host);
  const [clientName, setClientName] = useState("");
  const pathName = usePathname();
  const pageName = getPageName(pathName);

  useEffect(() => {
    const cName = getCookie("client_name") || "";
    setClientName(cName);
    if (cName === "zuno") {
      const headerScript = getZunoScript("footer");
      loadScript(headerScript);
    }
  }, []);

  if (isLoading) return <FooterSkeleton />;
  if (isError) return <div>Error loading data. Please try again later.</div>;

  return (
    <div
      className={`mb-[54px] md:mb-0 ${isLoggedIn && pageName === "Home" ? "custom-cursor" : ""}`}
      id="seekerFooter"
    >
      {pageName === "Job Details" && clientName === "zuno" ? (
        <div id="zuno-header">
          {/* @ts-expect-error: This custom element is not recognized by TypeScript */}
          <footer-zuno></footer-zuno>
        </div>
      ) : (
        <Footer
          rightFooterData={prepareRightFooterData(
            data?.MODULE_RIGHT_FOOTER_REACT_CORE || [],
            host,
          )}
          leftFooterData={prepareLeftFooterData(
            data?.MODULE_LEFT_FOOTER_REACT_CORE || [],
          )}
          showBanner={false}
          isLoggedIn={isLoggedIn}
          channelName={siteProps?.region}
          // getEventdata={(data: EventTrackingDataType) => {
          //   cleverTapAndMixPanelEvents.track(data.eventName, {
          //     ...data.ctProp,
          //   });
          // }}
        />
      )}
    </div>
  );
};

export default FooterComponent;
